import {
  AdvancedFeasibilityFilters,
  FeasibilityAdvancedFilterType,
} from '../models';

export const ADVANCED_FILTER_TYPE: Record<
  'EXCLUDE' | 'INCLUDE',
  FeasibilityAdvancedFilterType
> = {
  EXCLUDE: 'exclude',
  INCLUDE: 'include',
};

export const EMPTY_ADVANCED_FEASIBILITY_FILTERS: AdvancedFeasibilityFilters = {
  type: ADVANCED_FILTER_TYPE.EXCLUDE,
  dateRange: { start: null, end: null },
  criteria: [],
  matchedGroupIds: [],
  manualGroupIds: [],
  respondentStatuses: [],
  excludeFromFeasibleAudience: false,
  psidRefs: [],
};

export const NO_PSIDS_FOUND_MESSAGE = 'There are no PSIDs for this selection.';

export const CHILD_FEASIBILITY_UNAVAILABLE_MESSAGE =
  'Locale cannot be estimated yet';

export const FEASIBILITY_ERROR_MESSAGES = {
  QUOTA_DISTRIBUTION: (quotaLabel: string): string =>
    `Quota allocation for ${quotaLabel} qualification is equal or less than zero. Please check and edit the quota allocation and save again.`,
  SERVICE_UNAVAILABLE:
    'Feasibility Service appears to be unavailable at the moment, please contact support.',
  NOT_PROCESSED:
    'Feasibility could not be processed at the moment, please contact support.',
} as const;

export const FEASIBILITY_QUOTA_REJECTION = {
  MARKER: 'required_count should be >= 0',
  INDEX_PATTERN: /data\.quotas\[(\d+)\]/,
} as const;
